import styled from 'styled-components';

type ParsedContentProps = {
  textAlign?: string;
  color?: string;
}

export const ParsedContentWrapper = styled.div<ParsedContentProps>`
  margin-bottom: 1.5em;
  text-align: ${({ textAlign }) => textAlign};
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    color: ${({ color }) => color};
  }

  [class*='Headingstyle__Heading-sc'] {
    font-weight: 400 !important;
    margin-top: 1.5rem;
  }

  li {
    line-height: 1.5;
  }
`;
